import { getState } from './storage';

const STRINGS = {
  ms: {
    start: 'Mula Bermain', tagline: 'Main. Belajar. Berkembang.',
    hello: 'Hai', chooseWorld: 'Pilih dunia untuk bermain',
    // World-map banners. {n} is replaced by the caller, like growthLine does.
    worldNumber: 'Dunia {n}', worldProBanner: 'Dunia Pro — buka dengan Pro',
    journeyEnd: 'Itu semua dunia Piko.',
    garden: 'Taman Warna', forest: 'Hutan Bunyi', island: 'Pulau Memori',
    shapes: 'Padang Bentuk', size: 'Pantai Saiz', animals: 'Kebun Haiwan', move: 'Bilik Gerak', daily: 'Dunia Harian',
    parentArea: 'Ruang Ibu Bapa', parentPanel: 'Ibu Bapa', holdToEnter: 'Tekan dan tahan 3 saat',
    gateTask: 'Tekan nombor', wrongGate: 'Cuba lagi',
    mission: 'Misi di Rumah', missionDone: 'Siap!', missionSkip: 'Langkau',
    starEarned: 'bintang', feedPiko: 'Beri Piko Makan', done: 'Selesai',
    goodbye: 'Masa untuk berehat. Jumpa lagi!', playAgainLater: 'Sambung lain kali ya',
    backHome: 'Balik', pause: 'Rehat sebentar', resume: 'Sambung', exit: 'Keluar',
    replay: 'Dengar semula', lockedMsg: 'Minta ibu atau ayah buka aktiviti ini.',
    settings: 'Tetapan', reports: 'Laporan', upgrade: 'PintarPlay Pro',
    language: 'Bahasa', bilingualMode: 'Mod Dwibahasa', voiceLbl: 'Suara', musicLbl: 'Muzik', sfxLbl: 'Kesan Bunyi',
    sessionLen: 'Tempoh Sesi', missionsLbl: 'Misi Pergerakan & Rumah',
    resetProgress: 'Set Semula Kemajuan', deleteProfile: 'Padam Profil',
    privacy: 'Privasi', about: 'Tentang PintarPlay', version: 'Versi Aplikasi',
    recentSessions: 'Sesi Terkini', skillSummary: 'Ringkasan Kemahiran', suggested: 'Cadangan Aktiviti di Rumah',
    momentsTitle: 'Kali Pertama',
    shareTitle: 'Kongsi Minggu Ini',
    shareDesc: 'Satu gambar untuk dihantar kepada keluarga. Ia mengandungi nama pertama {name}, momen minggu ini, bintang dikumpul, dan kemahiran paling kerap dimain — tiada umur, tiada markah, tiada perbandingan.',
    shareMake: 'Buat gambar',
    shareSend: 'Hantar',
    shareAgain: 'Buat semula',
    shareBusy: 'Sedang membuat...',
    growthTitle: 'Kemajuan {name}',
    growthLine: '{weeks} minggu lepas dia perlu {before} cubaan. Sekarang {now}.',
    growthSteady: 'Dia kekal stabil pada {now} cubaan setiap pusingan.',
    growthEarly: 'Piko masih mengenali {name}. Selepas dua minggu bermain, kemajuan dia akan muncul di sini.',
    momentsEmpty: '{name} baru bermula. Momen pertama dia akan muncul di sini.',
    mFirstGame: '{name} habiskan {game} buat kali pertama.',
    mFirstPerfect: '{name} dapat semua betul dalam {game} tanpa tersilap sekali pun.',
    mFirstSkill: '{name} mula belajar {skill}.',
    mFirstWorld: '{name} habiskan seluruh {world}.',
    price: 'RM14.50 / bulan', subscribe: 'Langgan', managePro: 'Urus Pro',
    freePlan: 'PintarPlay Percuma', proPlan: 'PintarPlay Pro',
    minutes: 'minit', save: 'Simpan', cancel: 'Batal', logout: 'Log Keluar',
    playAgain: 'Main Lagi', playAgainHint: 'Main sekali lagi untuk kumpul lebih bintang!',
    tryFirst: 'Cuba dulu', trialEndMsg: 'Piko ada {m} permainan lagi macam ni!',
    upgradePersonal: '{name} dah siapkan {n} permainan. Ada {m} lagi menanti dalam Pro.',
    upgGames: 'Game disiapkan', upgSkill: 'Kemahiran kerap dimain', upgStars: 'Bintang terkumpul',
    affiliate: 'Rakan Affiliate',
    affiliateTitle: 'Program Affiliate Pro',
    affiliateIntro: 'Kongsi PintarPlay. Anda menerima 10% bagi setiap bayaran MYR yang layak selepas tempoh menunggu.',
    affiliateLocked: 'Program affiliate tersedia untuk ibu bapa Pro yang sedang aktif sahaja.',
    affiliateShareLink: 'Pautan rujukan anda',
    affiliateCopyLink: 'Salin pautan',
    affiliateCopied: 'Pautan disalin',
    affiliateLifetimeEarned: 'Jumlah komisen',
    affiliatePending: 'Menunggu 14 hari',
    affiliateAvailable: 'Boleh dikeluarkan',
    affiliatePaid: 'Telah dibayar',
    affiliateReserved: 'Permintaan menunggu',
    affiliateNegative: 'Baki negatif selepas bayaran balik',
    affiliateMinimum: 'Tetapan semasa untuk pengeluaran minimum ialah RM50.',
    affiliateHoldNote: 'Komisen tersedia selepas tempoh menunggu 14 hari.',
    affiliateRecurringNote: 'Belum disahkan untuk pelancaran: komisen berulang atau untuk bayaran pertama sahaja; pengeluaran minimum RM50; dan dasar penarikan balik komisen apabila bayaran balik berlaku.',
    affiliateWithdraw: 'Minta pengeluaran',
    affiliateHolder: 'Nama pemegang akaun',
    affiliateBank: 'Nama bank',
    affiliateAccount: 'Nombor akaun',
    affiliateConsent: 'Saya bersetuju nama pemegang, bank dan nombor akaun digunakan hanya untuk pemindahan manual komisen. Data disulitkan dan dipadam 90 hari selepas permintaan diselesaikan.',
    affiliatePayoutPromise: 'Pembayaran manual dalam 24–48 jam. Jika lewat, hubungi sokongan.',
    affiliateSubmit: 'Hantar permintaan',
    affiliateSubmitting: 'Menghantar…',
    affiliateRequested: 'Permintaan pengeluaran diterima.',
    affiliateHistory: 'Sejarah pengeluaran',
    affiliateHistoryEmpty: 'Belum ada permintaan pengeluaran.',
    affiliateStatusPending: 'Menunggu',
    affiliateStatusPaid: 'Dibayar',
    affiliateStatusRejected: 'Ditolak',
    affiliateSupport: 'Hubungi sokongan',
    affiliateLoadError: 'Dashboard affiliate tidak dapat dimuatkan.',
    affiliateAdminTitle: 'Pembayaran Affiliate',
    affiliateAdminDenied: 'Akaun ini tidak dibenarkan mengurus pembayaran affiliate.',
    affiliateAdminQueue: 'Permintaan menunggu',
    affiliateAdminEmpty: 'Tiada permintaan menunggu.',
    affiliateAdminOpen: 'Buka butiran',
    affiliateAdminAge: 'Umur permintaan',
    affiliateAdminWarning: 'Amaran 24 jam',
    affiliateAdminBreach: 'Melebihi janji 48 jam',
    affiliateAdminDetail: 'Butiran pembayaran tunggal',
    affiliateAdminReference: 'Rujukan pembayaran luar',
    affiliateAdminMarkPaid: 'Tandakan dibayar',
    affiliateAdminRejectReason: 'Sebab penolakan',
    affiliateAdminReject: 'Tolak dan pulangkan baki',
    affiliateAdminClose: 'Tutup butiran',
    affiliateAdminPaidSuccess: 'Permintaan ditandakan dibayar.',
    affiliateAdminUnauthenticated: 'Log masuk dengan akaun pentadbir untuk meneruskan.',
    affiliateAdminBack: 'Kembali ke PintarPlay',
    affiliateAdminHours: 'jam',
    affiliateAdminRequestedAt: 'Diminta',
    affiliateAdminAmount: 'Jumlah',
    weeklyWaConsent: 'Saya bersetuju menerima laporan kemajuan mingguan PintarPlay melalui WhatsApp untuk nombor ini. Persetujuan khusus ini boleh ditarik balik bila-bila masa. Polisi: weekly-whatsapp-v1.',
    weeklyWaEnabled: 'Laporan mingguan WhatsApp diaktifkan',
    weeklyWaDisabled: 'Laporan mingguan WhatsApp dimatikan',
    weeklyWaEnable: 'Aktifkan laporan mingguan',
    weeklyWaDisable: 'Matikan laporan mingguan',
    weeklyWaAlready: 'Laporan minggu ini sudah dihantar atau sedang diproses.',
  },
  en: {
    start: 'Start Playing', tagline: 'Play. Learn. Grow.',
    hello: 'Hi', chooseWorld: 'Choose a world to play',
    worldNumber: 'World {n}', worldProBanner: 'Pro world — unlock with Pro',
    journeyEnd: "That's all of Piko's worlds.",
    garden: 'Colour Garden', forest: 'Sound Forest', island: 'Memory Island',
    shapes: 'Shape Field', size: 'Size Beach', animals: 'Animal Garden', move: 'Move Room', daily: 'Everyday World',
    parentArea: 'Parent Area', parentPanel: 'Parent Panel', holdToEnter: 'Press and hold for 3 seconds',
    gateTask: 'Tap the number', wrongGate: 'Try again',
    mission: 'Home Mission', missionDone: 'Done!', missionSkip: 'Skip',
    starEarned: 'stars', feedPiko: 'Feed Piko', done: 'Done',
    goodbye: "It's time to rest. See you again!", playAgainLater: 'Continue another time',
    backHome: 'Home', pause: 'Take a break', resume: 'Continue', exit: 'Exit',
    replay: 'Hear again', lockedMsg: 'Ask mum or dad to open this activity.',
    settings: 'Settings', reports: 'Reports', upgrade: 'PintarPlay Pro',
    language: 'Language', bilingualMode: 'Bilingual Mode', voiceLbl: 'Voice', musicLbl: 'Music', sfxLbl: 'Sound Effects',
    sessionLen: 'Session Duration', missionsLbl: 'Movement & Home Missions',
    resetProgress: 'Reset Progress', deleteProfile: 'Delete Profile',
    privacy: 'Privacy', about: 'About PintarPlay', version: 'App Version',
    recentSessions: 'Recent Sessions', skillSummary: 'Skill Summary', suggested: 'Suggested Home Activities',
    momentsTitle: 'First Times',
    shareTitle: 'Share this week',
    shareDesc: "One picture to send to family. It contains {name}'s first name, this week's moments, stars collected, and the most practised skill — no age, no scores, no comparisons.",
    shareMake: 'Make picture',
    shareSend: 'Send',
    shareAgain: 'Make again',
    shareBusy: 'Making...',
    growthTitle: "{name}'s progress",
    growthLine: '{weeks} weeks ago they needed {before} tries. Now {now}.',
    growthSteady: 'They are holding steady at {now} tries per round.',
    growthEarly: 'Piko is still getting to know {name}. After two weeks of playing, their progress will appear here.',
    momentsEmpty: '{name} is just getting started. Their first moments will appear here.',
    mFirstGame: '{name} finished {game} for the first time.',
    mFirstPerfect: '{name} got every answer right in {game}, without a single miss.',
    mFirstSkill: '{name} started learning {skill}.',
    mFirstWorld: '{name} finished all of {world}.',
    price: 'RM14.50 / month', subscribe: 'Subscribe', managePro: 'Manage Pro',
    freePlan: 'PintarPlay Free', proPlan: 'PintarPlay Pro',
    minutes: 'minutes', save: 'Save', cancel: 'Cancel', logout: 'Log Out',
    playAgain: 'Play Again', playAgainHint: 'Play again to earn more stars!',
    tryFirst: 'Try it', trialEndMsg: 'Piko has {m} more games like this!',
    upgradePersonal: '{name} has completed {n} games. {m} more are waiting in Pro.',
    upgGames: 'Games completed', upgSkill: 'Most played skill', upgStars: 'Stars collected',
    affiliate: 'Affiliate',
    affiliateTitle: 'Pro Affiliate Programme',
    affiliateIntro: 'Share PintarPlay. You receive 10% of each eligible settled MYR payment after the hold.',
    affiliateLocked: 'The affiliate programme is available only to parents with current Pro access.',
    affiliateShareLink: 'Your referral link',
    affiliateCopyLink: 'Copy link',
    affiliateCopied: 'Link copied',
    affiliateLifetimeEarned: 'Lifetime commission',
    affiliatePending: 'Pending 14 days',
    affiliateAvailable: 'Available',
    affiliatePaid: 'Paid out',
    affiliateReserved: 'Request pending',
    affiliateNegative: 'Negative after refund clawback',
    affiliateMinimum: 'The current minimum-withdrawal setting is RM50.',
    affiliateHoldNote: 'Commission becomes available after a 14-day hold.',
    affiliateRecurringNote: 'Not yet confirmed for launch: recurring versus first-payment-only commission; the RM50 minimum withdrawal; and the refund-clawback policy.',
    affiliateWithdraw: 'Request withdrawal',
    affiliateHolder: 'Account holder name',
    affiliateBank: 'Bank name',
    affiliateAccount: 'Account number',
    affiliateConsent: 'I consent to the holder name, bank, and account number being used only for manual commission transfer. The encrypted data is deleted 90 days after the request is resolved.',
    affiliatePayoutPromise: 'Manual payout within 24–48 hours. Contact support if it is late.',
    affiliateSubmit: 'Submit request',
    affiliateSubmitting: 'Submitting…',
    affiliateRequested: 'Withdrawal request received.',
    affiliateHistory: 'Withdrawal history',
    affiliateHistoryEmpty: 'No withdrawal requests yet.',
    affiliateStatusPending: 'Pending',
    affiliateStatusPaid: 'Paid',
    affiliateStatusRejected: 'Rejected',
    affiliateSupport: 'Contact support',
    affiliateLoadError: 'The affiliate dashboard could not be loaded.',
    affiliateAdminTitle: 'Affiliate Payouts',
    affiliateAdminDenied: 'This account is not allowed to manage affiliate payouts.',
    affiliateAdminQueue: 'Pending requests',
    affiliateAdminEmpty: 'There are no pending requests.',
    affiliateAdminOpen: 'Open detail',
    affiliateAdminAge: 'Request age',
    affiliateAdminWarning: '24-hour warning',
    affiliateAdminBreach: 'Past 48-hour promise',
    affiliateAdminDetail: 'Single payout detail',
    affiliateAdminReference: 'External payout reference',
    affiliateAdminMarkPaid: 'Mark paid',
    affiliateAdminRejectReason: 'Rejection reason',
    affiliateAdminReject: 'Reject and release balance',
    affiliateAdminClose: 'Close detail',
    affiliateAdminPaidSuccess: 'Request marked paid.',
    affiliateAdminUnauthenticated: 'Sign in with an administrator account to continue.',
    affiliateAdminBack: 'Back to PintarPlay',
    affiliateAdminHours: 'hours',
    affiliateAdminRequestedAt: 'Requested',
    affiliateAdminAmount: 'Amount',
    weeklyWaConsent: 'I agree to receive PintarPlay weekly progress reports by WhatsApp at this number. This purpose-specific consent can be withdrawn at any time. Policy: weekly-whatsapp-v1.',
    weeklyWaEnabled: 'Weekly WhatsApp reports are enabled',
    weeklyWaDisabled: 'Weekly WhatsApp reports are off',
    weeklyWaEnable: 'Enable weekly reports',
    weeklyWaDisable: 'Turn off weekly reports',
    weeklyWaAlready: 'This week’s report was already sent or is being processed.',
  },
};

export function lang() {
  const l = getState().profile.language;
  return l === 'en' ? 'en' : 'ms';
}

export function t(key) {
  return STRINGS[lang()][key] || STRINGS.ms[key] || key;
}
